
import { sentAtText } from '~/util/summary-copy'

export default {
    props: {
        // the newest frozen copy (GET /summary/{id}/copy/): date, by, url
        copy: { type: Object, required: true },
        // the live summary: `updated` says whether it changed after that send
        summary: { type: Object, default: null },
        clientName: { type: String, default: 'The client' },
    },
    computed: {
        sentAt () { return sentAtText(this.copy.date, this.$moment) },
        editedSince () {
            const updated = this.summary && this.summary.updated
            return !!updated && this.$moment(updated).isAfter(this.copy.date)
        },
        editedAt () { return sentAtText(this.summary.updated, this.$moment) },
    },
}
